import { ApiRequest } from "./base";

const apiRoute = "config";

async function fetchConfig(request?: Request) {
	const query = new URLSearchParams();
	if (request) {
		const searchParams = new URL(request.url).searchParams;
		const peak = searchParams.get("peak")?.trim().toLowerCase();
		if (peak) {
			// PHP resolves the peak name using the IDs in its $peaks array.
			query.set("peak", peak);
			if (searchParams.has("headers")) query.set("headers", searchParams.get("headers"));
		}
	}
	const queryString = query.size ? `?${query}` : "";
	const { session_id, promo_banner, peak_configs, navigation, reviews, cutoffs, current_peak, current_peak_id } =
		await ApiRequest(`${apiRoute}/${queryString}`, "GET");
	return { session_id, promo_banner, peak_configs, navigation, reviews, cutoffs, current_peak, current_peak_id };
}

export const ConfigApi = {
	async GetConfig(request?: Request) {
		return fetchConfig(request);
	},
};
